import { render, staticRenderFns } from "./scope.vue?vue&type=template&id=e940d1b6"
import script from "./scope.ts?vue&type=script&lang=js&external"
export * from "./scope.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports